import { DeepPartial, ResultComponentsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_RESULTS_CONFIG: DeepPartial<ResultComponentsConfig> = {
  link: {
    children: {
      price: {
        component: 'TuandcoResultPrice'
      },
      image: {
        children: {
          brokenImage: {
            component: 'TuandcoImageBroken'
          }
        }
      }
    }
  }

};
